import type { OnlineAgentsCheck } from '@/common/api/models.pleased';
import type { WaitTimes } from '@/components/chat/messages/ConnectOptionsMessage/useWaitTimes';

export interface MockedConnectData {
  queuePosition: number;
  agentsOnline: OnlineAgentsCheck;
  waitTimes: WaitTimes;
}

/**
 * Create mocked connect data with chat wait time exceeding the limit
 */
export const createMockedConnectData = (): MockedConnectData => {
  return {
    queuePosition: 2,
    agentsOnline: {
      onlineChatAgentsCheck: true,
      onlineCallAgentsCheck: true,
    },
    waitTimes: {
      chat: '12-15 minutes', // Exceeds normal limit
      call: '3-4 minutes', // Normal wait time
    },
  };
};
